
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useEffect, useState,useRef } from 'react';
import posService, { GetOtherPosProducts } from "../../services/pos/pos.service";
import { Toast } from "primereact/toast";

interface RequestProductProps {
  visible: boolean;
  onHide: () => void;
  product: any;
  setLoading: (loading: boolean) => void;
}

const RequestProduct: React.FC<RequestProductProps> = ({ visible, onHide, product,setLoading }) => {
  const toast = useRef<Toast>(null);
  const [quantity, setQuantity] = useState<number>(0);
  const [otherPOSStock, setOtherPOSStock] = useState<any[]>([]);
  const [selectedPOS, setSelectedPOS] = useState<any>(null);

  useEffect(() => {
    if (visible && product) {
      GetOtherPosProducts(product.posId, product.productId).then((response) => {
        if (response) {
          setOtherPOSStock(response);
        }
      });
    }
  }, [visible, product]);

  useEffect(() => {
  if (!visible) {
    setQuantity(0);
    setSelectedPOS(null);
  }
}, [visible]);

  const handleSubmit = async () => {
    if (!quantity || quantity <= 0) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please enter a quantity.",
    });
    return;
  }

  if (!selectedPOS) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please select a POS.",
    });
    return;
  }

  if (product.measurementTypeId === 4 && !Number.isInteger(quantity)) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Decimal quantities are not allowed for this product.",
    });
    return;
  }

  const selectedStock = otherPOSStock.find((pos) => pos.posId === selectedPOS);

  if (quantity > selectedStock.currentStock) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: `Requested quantity (${quantity}) exceeds available stock (${selectedStock.currentStock}) in selected POS.`,
    });
    return;
  }

 const requestPayload = {
    productId: product.productId,
    requestFromPOS: product.posId,
    requestToPOS: selectedPOS,
    quantity: quantity,
  };

  try {
    setLoading(true);
    const response = await posService.AddPosrequest(requestPayload);
    if (response?.isSuccess) {
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: response.message || "Product request sent successfully",
      });
      onHide();
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: response?.message || "Failed to submit product request",
      });
    }
  } catch (error) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "An error occurred while submitting the request",
    });
    console.error('Error submitting request', error);

  }finally {
    setLoading(false); // Always stop loading
  }
  };

 return (
  <>
  <Toast ref={toast} />
  <Dialog header="Request Product" visible={visible} style={{ width: '35vw' }} onHide={onHide} className="p-fluid">
    <div className="p-3">
      <div className="mb-3">
        <label className="font-semibold text-sm block mb-1">Product</label>
        <div className="p-inputtext p-component bg-gray-100 py-2 px-3 rounded">
          {product?.productName || '-'}
        </div>
      </div>

      <div className="mb-3">
        <label className="font-semibold text-sm block mb-1">Request Quantity <span className="text-danger">*</span></label>
        <InputText
          type="number"
          min="0"
          keyfilter="pnum"
          // value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          placeholder="Enter quantity"
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
        />
      </div>

      <div className="mb-3">
        <label className="font-semibold text-sm block mb-1">Select POS to Request From <span className="text-danger">*</span></label>
     <Dropdown
  value={selectedPOS}
  options={otherPOSStock}
  optionLabel="posCode"
  optionValue="posId"
  onChange={(e) => setSelectedPOS(e.value)}
  placeholder="Select POS"
  className="w-full"
  style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
  itemTemplate={(option) => (
    <div className="flex justify-between items-center w-full">
      <span>
        {option.posCode} (Quantity: {option.currentStock})
      </span>
      {option.currentStock < option.safetyStock && (
        <i
          className="pi pi-exclamation-triangle text-yellow-600 ml-2"
          title="Below safety stock"
        />
      )}
    </div>
  )}
  valueTemplate={(option) =>
    option ? (
      <div className="flex justify-between items-center w-full">
        <span>
          {option.posCode} (Quantity: {option.currentStock})
        </span>
        {option.currentStock < option.safetyStock && (
          <i
            className="pi pi-exclamation-triangle text-yellow-600 ml-2"
            title="Below safety stock"
          />
        )}
      </div>
    ) : (
      <span>Select POS</span>
    )
  }
/>
      </div>

      <div className="flex justify-end pt-2">
        <Button label="Submit Request" icon="pi pi-check" onClick={handleSubmit} />
      </div>
    </div>
  </Dialog>
  </>
);
};

export default RequestProduct;
